__webpack_require__.p = "/rimapi-dashboard/";